// extracted by mini-css-extract-plugin
module.exports = {"wrap":"divider_wrap__UjVkk","divider":"divider_divider__j7bqo","dot":"divider_dot__yiMX1","deleteBtn":"divider_deleteBtn__QC_5G"};